
// // // import React, { useState, useEffect } from 'react';
// // // import { useNavigate } from 'react-router-dom';
// // // import { db, collection, getDocs, addDoc, deleteDoc, updateDoc, doc } from '../firebase';
// // // import { Container, Grid, Card, CardContent, CardMedia, Typography, Button, Box, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Switch, FormControlLabel } from '@mui/material';
// // // import CloseIcon from '@mui/icons-material/Close';
// // // import { useAuth } from '../AuthContext';
// // // import * as XLSX from 'xlsx';

// // // const ManageItemsK = () => {
// // //   const [items, setItems] = useState([]);
// // //   const [selectedItem, setSelectedItem] = useState(null);
// // //   const [open, setOpen] = useState(false);
// // //   const [name, setName] = useState('');
// // //   const [category, setCategory] = useState('');
// // //   const [description, setDescription] = useState('');
// // //   const [isAvailable, setIsAvailable] = useState(false);  // Updated to boolean
// // //   const [image, setImage] = useState('');
// // //   const { currentUser } = useAuth();
// // //   const navigate = useNavigate();

// // //   useEffect(() => {
// // //     if (!currentUser) {
// // //       navigate('/');
// // //       return;
// // //     }
// // //     fetchItems();
// // //   }, [currentUser, navigate]);

// // //   const fetchItems = async () => {
// // //     const itemsCollection = await getDocs(collection(db, 'items_clear'));
// // //     const itemsData = itemsCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
// // //     setItems(itemsData);
// // //   };

// // //   const handleClickOpen = (item) => {
// // //     setSelectedItem(item);
// // //     setName(item.name || '');
// // //     setCategory(item.category || '');
// // //     setImage(item.image || '');
// // //     setDescription(item.description || '');
// // //     setIsAvailable(item.isAvailable || false);  // Ensure default is boolean
// // //     setOpen(true);
// // //   };

// // //   const renameKeys = (array, keyMap) => {
// // //     array.forEach(obj => {
// // //       for (const oldKey in keyMap) {
// // //         if (obj.hasOwnProperty(oldKey)) {
// // //           const newKey = keyMap[oldKey];
// // //           obj[newKey] = obj[oldKey];
// // //           delete obj[oldKey];
// // //         }
// // //       }
// // //     });
// // //   };

// // //   const keyMap = {
// // //     category: "קטגוריה",
// // //     image: "תמונה",
// // //     name: "שם מוצר",
// // //     description: 'תיאור',
// // //     isAvailable: 'במלאי'
// // //   };

// // //   const downloadExcel = () => {
// // //     let exData = items;
// // //     renameKeys(exData, keyMap);
// // //     const worksheet = XLSX.utils.json_to_sheet(exData);
// // //     const workbook = XLSX.utils.book_new();
// // //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Items');
// // //     XLSX.writeFile(workbook, 'items.xlsx');
// // //   };

// // //   const handleClose = () => {
// // //     setOpen(false);
// // //     setSelectedItem(null);
// // //   };

// // //   const handleSave = async () => {
// // //     try {
// // //       if (selectedItem && selectedItem.id) {
// // //         const itemDoc = doc(db, 'items_clear', selectedItem.id);
// // //         await updateDoc(itemDoc, {
// // //           name,
// // //           category,
// // //           description,
// // //           image,
// // //           isAvailable,
// // //         });
// // //       } else {
// // //         await addDoc(collection(db, 'items_clear'), {
// // //           name,
// // //           category,
// // //           description,
// // //           image,
// // //           isAvailable,
// // //         });
// // //       }
// // //       fetchItems();
// // //       handleClose();
// // //     } catch (error) {
// // //       console.error("Error saving item: ", error);
// // //     }
// // //   };

// // //   const handleDelete = async (id) => {
// // //     await deleteDoc(doc(db, 'items_clear', id));
// // //     fetchItems();
// // //   };

// // //   return (
// // //     <Container sx={{ paddingTop: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
// // //       <Box sx={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between' }}>
// // //         <Button variant="contained" color="primary" onClick={downloadExcel}>הוצאת פריטים לאקסל</Button>
// // //         <Button variant="contained" color="secondary" onClick={() => navigate('/order_g')}>הצגת גרפים</Button>
// // //       </Box>

// // //       <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
// // //         <Grid container spacing={2} alignItems="center">
// // //           {items.map(item => (
// // //             <Grid item xs={6} sm={4} md={2} key={item.id}>
// // //               <Card sx={{ width: '100px', height: '100px', backgroundColor: '#fff', color: '#333', border: '1px solid #ddd', borderRadius: '50%', overflow: 'hidden', textAlign: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', position: 'relative', margin: '0 auto' }}>
// // //                 <CardMedia
// // //                   component="img"
// // //                   alt={item.name}
// // //                   image={item.image}
// // //                   sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
// // //                   onClick={() => handleClickOpen(item)}
// // //                 />
// // //                 <CardContent sx={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', color: '#fff', padding: '2px 0' }}>
// // //                   <Typography variant="body2" sx={{ fontSize: '10px' }}>{item.name}</Typography>
// // //                 </CardContent>
// // //               </Card>
// // //               <Button variant="contained" color="primary" size="small" onClick={() => handleClickOpen(item)} sx={{ marginTop: '10px', marginRight: '5px', marginLeft: '5px' }}>Edit</Button>
// // //               <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(item.id)} sx={{ marginTop: '10px' }}>Delete</Button>
// // //             </Grid>
// // //           ))}
// // //         </Grid>
// // //       </div>

// // //       <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
// // //         <DialogTitle>
// // //           {selectedItem ? 'Edit Item' : 'Add Item'}
// // //           <IconButton
// // //             aria-label="close"
// // //             onClick={handleClose}
// // //             sx={{
// // //               position: 'absolute',
// // //               right: 8,
// // //               top: 8,
// // //               color: (theme) => theme.palette.grey[500],
// // //             }}
// // //           >
// // //             <CloseIcon />
// // //           </IconButton>
// // //         </DialogTitle>
// // //         <DialogContent dividers>
// // //           <TextField
// // //             margin="dense"
// // //             label="Name"
// // //             type="text"
// // //             fullWidth
// // //             variant="outlined"
// // //             value={name}
// // //             onChange={(e) => setName(e.target.value)}
// // //             sx={{ marginBottom: '20px' }}
// // //           />
// // //           <TextField
// // //             margin="dense"
// // //             label="Category"
// // //             type="text"
// // //             fullWidth
// // //             variant="outlined"
// // //             value={category}
// // //             onChange={(e) => setCategory(e.target.value)}
// // //             sx={{ marginBottom: '20px' }}
// // //           />
// // //           <TextField
// // //             margin="dense"
// // //             label="Description"
// // //             type="text"
// // //             fullWidth
// // //             variant="outlined"
// // //             value={description}
// // //             onChange={(e) => setDescription(e.target.value)}
// // //             sx={{ marginBottom: '20px' }}
// // //           />
// // //           {/* Toggle for 'In Stock' Status */}
// // //           <FormControlLabel
// // //             control={
// // //               <Switch
// // //                 checked={isAvailable}
// // //                 onChange={(e) => setIsAvailable(e.target.checked)}
// // //                 color="primary"
// // //               />
// // //             }
// // //             label="In Stock"
// // //             sx={{ marginBottom: '20px' }}
// // //           />
// // //           <TextField
// // //             margin="dense"
// // //             label="Image URL"
// // //             type="text"
// // //             fullWidth
// // //             variant="outlined"
// // //             value={image}
// // //             onChange={(e) => setImage(e.target.value)}
// // //           />
// // //         </DialogContent>
// // //         <DialogActions>
// // //           <Button onClick={handleClose} color="secondary">Cancel</Button>
// // //           <Button onClick={handleSave} color="primary">Save</Button>
// // //         </DialogActions>
// // //       </Dialog>
// // //       {/* Button to add a new item */}
// // //       <Button variant="contained" color="primary" onClick={() => handleClickOpen({})} sx={{ marginTop: '20px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>Add Item</Button>
// // //     </Container>
// // //   );
// // // };

// // // export default ManageItemsK;



// // import React, { useState, useEffect } from 'react';
// // import { useNavigate } from 'react-router-dom';
// // import { db, collection, getDocs, addDoc, deleteDoc, updateDoc, doc } from '../firebase';
// // import { Container, Grid, Card, CardContent, CardMedia, Typography, Button, Box, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Switch, FormControlLabel } from '@mui/material';
// // import CloseIcon from '@mui/icons-material/Close';
// // import { useAuth } from '../AuthContext';
// // import * as XLSX from 'xlsx';

// // const ManageItemsK = () => {
// //   const [items, setItems] = useState([]);
// //   const [selectedItem, setSelectedItem] = useState(null);
// //   const [open, setOpen] = useState(false);
// //   const [name, setName] = useState('');
// //   const [category, setCategory] = useState('');
// //   const [description, setDescription] = useState('');
// //   const [isAvailable, setIsAvailable] = useState(false);  // Updated to boolean
// //   const [image, setImage] = useState('');
// //   const { currentUser } = useAuth();
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     if (!currentUser) {
// //       navigate('/');
// //       return;
// //     }
// //     fetchItems();
// //   }, [currentUser, navigate]);


// //   const changeBodyBackground = (background) => {
// //     document.body.style.background = background;
// //   };


// //   useEffect(() => {
// //     changeBodyBackground('linear-gradient(to bottom, #9aa3e5, rgba(213, 213, 187, 0))');
// //     return () => changeBodyBackground(''); // Reset background on unmount
// //   }, []);


// //   const fetchItems = async () => {
// //     const itemsCollection = await getDocs(collection(db, 'items_clear'));
// //     const itemsData = itemsCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
// //     setItems(itemsData);
// //   };

// //   const handleClickOpen = (item) => {
// //     setSelectedItem(item);
// //     setName(item.name || '');
// //     setCategory(item.category || '');
// //     setImage(item.image || '');
// //     setDescription(item.description || '');
// //     setIsAvailable(item.isAvailable || false);  // Ensure default is boolean
// //     setOpen(true);
// //   };

// //   const renameKeys = (array, keyMap) => {
// //     array.forEach(obj => {
// //       for (const oldKey in keyMap) {
// //         if (obj.hasOwnProperty(oldKey)) {
// //           const newKey = keyMap[oldKey];
// //           obj[newKey] = obj[oldKey];
// //           delete obj[oldKey];
// //         }
// //       }
// //     });
// //   };

// //   const keyMap = {
// //     category: "קטגוריה",
// //     image: "תמונה",
// //     name: "שם מוצר",
// //     description: 'תיאור',
// //     isAvailable: 'במלאי'
// //   };

// //   const downloadExcel = () => {
// //     let exData = items;
// //     renameKeys(exData, keyMap);
// //     const worksheet = XLSX.utils.json_to_sheet(exData);
// //     const workbook = XLSX.utils.book_new();
// //     XLSX.utils.book_append_sheet(workbook, worksheet, 'Items');
// //     XLSX.writeFile(workbook, 'items.xlsx');
// //   };

// //   const handleClose = () => {
// //     setOpen(false);
// //     setSelectedItem(null);
// //   };

// //   const handleSave = async () => {
// //     try {
// //       if (selectedItem && selectedItem.id) {
// //         const itemDoc = doc(db, 'items_clear', selectedItem.id);
// //         await updateDoc(itemDoc, {
// //           name,
// //           category,
// //           description,
// //           image,
// //           isAvailable,
// //         });
// //       } else {
// //         await addDoc(collection(db, 'items_clear'), {
// //           name,
// //           category,
// //           description,
// //           image,
// //           isAvailable,
// //         });
// //       }
// //       fetchItems();
// //       handleClose();
// //     } catch (error) {
// //       console.error("Error saving item: ", error);
// //     }
// //   };

// //   const handleDelete = async (id) => {
// //     await deleteDoc(doc(db, 'items_clear', id));
// //     fetchItems();
// //   };

// //   return (
// //     <Container sx={{ paddingTop: '20px', backgroundColor: '#f0f0f0', minHeight: '100vh' }}>
// //       <Box sx={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', gap: 2 }}>
// //         <Button variant="contained" color="primary" onClick={downloadExcel} sx={{ marginRight: '10px' }}>הוצאת פריטים לאקסל</Button>
// //         <Button variant="contained" color="secondary" onClick={() => navigate('/order_g')} sx={{ marginRight: '10px' }}>לוח המחוונים </Button>
// //         {/* New Button to navigate to ManageUsers */}
// //         <Button variant="contained" color="info" onClick={() => navigate('/ManageUsers')} sx={{ marginRight: '10px' }}>ניהול משתמשים</Button>
// //       </Box>

// //       <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
// //         <Grid container spacing={2} alignItems="center">
// //           {items.map(item => (
// //             <Grid item xs={6} sm={4} md={2} key={item.id}>
// //               <Card sx={{ width: '100px', height: '100px', backgroundColor: '#fff', color: '#333', border: '1px solid #ddd', borderRadius: '50%', overflow: 'hidden', textAlign: 'center', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', position: 'relative', margin: '0 auto' }}>
// //                 <CardMedia
// //                   component="img"
// //                   alt={item.name}
// //                   image={item.image}
// //                   sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
// //                   onClick={() => handleClickOpen(item)}
// //                 />
// //                 <CardContent sx={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', color: '#fff', padding: '2px 0' }}>
// //                   <Typography variant="body2" sx={{ fontSize: '10px' }}>{item.name}</Typography>
// //                 </CardContent>
// //               </Card>
// //               <Button variant="contained" color="primary" size="small" onClick={() => handleClickOpen(item)} sx={{ marginTop: '10px', marginRight: '5px', marginLeft: '5px' }}>ערוך</Button>
// //               <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(item.id)} sx={{ marginTop: '10px' }}>מחק</Button>
// //             </Grid>
// //           ))}
// //         </Grid>
// //       </div>

// //       <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
// //         <DialogTitle>
// //           {selectedItem ? 'ערוך מוצר' : 'הוסף מוצר'}
// //           <IconButton
// //             aria-label="close"
// //             onClick={handleClose}
// //             sx={{
// //               position: 'absolute',
// //               right: 8,
// //               top: 8,
// //               color: (theme) => theme.palette.grey[500],
// //             }}
// //           >
// //             <CloseIcon />
// //           </IconButton>
// //         </DialogTitle>
// //         <DialogContent dividers>
// //           <TextField
// //             margin="dense"
// //             label="שם מוצר"
// //             type="text"
// //             fullWidth
// //             variant="outlined"
// //             value={name}
// //             onChange={(e) => setName(e.target.value)}
// //             sx={{ marginBottom: '20px' }}
// //           />
// //           <TextField
// //             margin="dense"
// //             label="קטגוריה"
// //             type="text"
// //             fullWidth
// //             variant="outlined"
// //             value={category}
// //             onChange={(e) => setCategory(e.target.value)}
// //             sx={{ marginBottom: '20px' }}
// //           />
// //           <TextField
// //             margin="dense"
// //             label="תיאור"
// //             type="text"
// //             fullWidth
// //             variant="outlined"
// //             value={description}
// //             onChange={(e) => setDescription(e.target.value)}
// //             sx={{ marginBottom: '20px' }}
// //           />
// //           {/* Toggle for 'In Stock' Status */}
// //           <FormControlLabel
// //             control={
// //               <Switch
// //                 checked={isAvailable}
// //                 onChange={(e) => setIsAvailable(e.target.checked)}
// //                 color="primary"
// //               />
// //             }
// //             label="במלאי"
// //             sx={{ marginBottom: '20px' }}
// //           />
// //           <TextField
// //             margin="dense"
// //             label="כתובת תמונה"
// //             type="text"
// //             fullWidth
// //             variant="outlined"
// //             value={image}
// //             onChange={(e) => setImage(e.target.value)}
// //           />
// //         </DialogContent>
// //         <DialogActions>
// //           <Button onClick={handleClose} color="secondary">ביטול</Button>
// //           <Button onClick={handleSave} color="primary">שמור</Button>
// //         </DialogActions>
// //       </Dialog>
// //       {/* Button to add a new item */}
// //       <Button variant="contained" color="primary" onClick={() => handleClickOpen({})} sx={{ marginTop: '20px', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}>הוסף מוצר</Button>
// //     </Container>
// //   );
// // };

// // export default ManageItemsK;



// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { db, collection, getDocs, addDoc, deleteDoc, updateDoc, doc } from '../firebase';
// import {
//   Container, Grid, Card, CardContent, CardMedia, Typography, Button, Box, TextField,
//   Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Switch, FormControlLabel, MenuItem, Select
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import { useAuth } from '../AuthContext';
// import { useSelector } from 'react-redux';

// const ManageItemsK = () => {
//   const [items, setItems] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [open, setOpen] = useState(false);
//   const [openUserModal, setOpenUserModal] = useState(false);
//   const [openUserEditModal, setOpenUserEditModal] = useState(false);
//   const [name, setName] = useState('');
//   const [category, setCategory] = useState('');
//   const [description, setDescription] = useState('');
//   const [isAvailable, setIsAvailable] = useState(false);
//   const [image, setImage] = useState('');
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [role, setRole] = useState('');
//   const [status, setStatus] = useState('');
//   const { currentUser } = useAuth();
//   const navigate = useNavigate();
//   const user = useSelector((state) => state.auth.currentUser);

//   useEffect(() => {
//     // Check if user is logged in and has an admin role
//     if (!user) {
//       navigate('/loginK');
//       return;
//     }

//     if (user.role !== 'admin') {
//       navigate('/loginK'); // Redirect if not admin
//     }
//   }, [user, navigate]);

//   const fetchItems = async () => {
//     const itemsCollection = await getDocs(collection(db, 'items_clear'));
//     const itemsData = itemsCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//     setItems(itemsData);
//   };

//   const fetchUsers = async () => {
//     const usersCollection = await getDocs(collection(db, 'users'));
//     const usersData = usersCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
//     setUsers(usersData);
//   };

//   const handleUserApproval = async (userId) => {
//     await updateDoc(doc(db, 'users', userId), { status: 'מאושר' });
//     fetchUsers();
//   };

//   const handleDeleteUser = async (userId) => {
//     await deleteDoc(doc(db, 'users', userId));
//     fetchUsers();
//   };

//   const handleEditUser = (user) => {
//     setSelectedUser(user);
//     setUsername(user.username);
//     setPassword(user.password);
//     setRole(user.role);
//     setStatus(user.status);
//     setOpenUserEditModal(true);
//   };

//   const handleSaveUserChanges = async () => {
//     if (selectedUser) {
//       await updateDoc(doc(db, 'users', selectedUser.id), {
//         username,
//         password,
//         role,
//         status
//       });
//       fetchUsers();
//       setOpenUserEditModal(false);
//     }
//   };

//   const handleCloseUserEditModal = () => {
//     setOpenUserEditModal(false);
//     setSelectedUser(null);
//     setUsername('');
//     setPassword('');
//     setRole('');
//     setStatus('');
//   };

//   // Open product edit dialog and set product details
//   const handleClickOpen = (item) => {
//     setSelectedItem(item);
//     setName(item.name || '');
//     setCategory(item.category || '');
//     setDescription(item.description || '');
//     setIsAvailable(item.isAvailable || false);
//     setImage(item.image || '');
//     setOpen(true);
//   };

//   // Save changes to product
//   const handleSaveProductChanges = async () => {
//     if (selectedItem) {
//       await updateDoc(doc(db, 'items_clear', selectedItem.id), {
//         name,
//         category,
//         description,
//         isAvailable,
//         image,
//       });
//       fetchItems();
//       setOpen(false);
//     }
//   };

//   const handleDelete = async (id) => {
//     await deleteDoc(doc(db, 'items_clear', id));
//     fetchItems();
//   };

//   return (
//     <Container
//       sx={{
//         paddingTop: '20px',
//         backgroundColor: '#f0f0f0',
//         minHeight: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         textAlign: 'center'
//       }}
//     >
//       <Box sx={{ marginBottom: '20px', display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
//         <Button variant="contained" color="primary" onClick={() => { /* downloadExcel function here */ }} sx={{ fontSize: '0.8rem' }}>ייצוא לאקסל</Button>
//         <Button variant="contained" color="secondary" onClick={() => navigate('/order_g')} sx={{ fontSize: '0.8rem' }}>לוח מחוונים</Button>
//         <Button variant="contained" color="info" onClick={() => setOpenUserModal(true)} sx={{ fontSize: '0.8rem' }}>ניהול משתמשים</Button>
//       </Box>

//       <Box sx={{ maxHeight: '60vh', overflowY: 'auto', width: '100%' }}>
//         <Grid container spacing={2}>
//           {items.map(item => (
//             <Grid item xs={6} sm={4} md={3} lg={2} key={item.id}>
//               <Card sx={{ backgroundColor: '#fff', borderRadius: '12px', overflow: 'hidden', textAlign: 'center' }}>
//                 <CardMedia
//                   component="img"
//                   alt={item.name}
//                   image={item.image}
//                   sx={{ width: '100%', height: '100px', objectFit: 'cover' }}
//                   onClick={() => handleClickOpen(item)}
//                 />
//                 <CardContent>
//                   <Typography variant="body2" noWrap sx={{ fontSize: '14px', fontWeight: 'bold' }}>{item.name}</Typography>
//                   <Button variant="contained" color="primary" size="small" onClick={() => handleClickOpen(item)} sx={{ mt: 1 }}>ערוך</Button>
//                   <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(item.id)} sx={{ mt: 1 }}>מחק</Button>
//                 </CardContent>
//               </Card>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>

//       {/* Product Edit Modal */}
//       <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           {selectedItem ? 'עריכת מוצר' : 'הוספת מוצר'}
//           <IconButton
//             aria-label="close"
//             onClick={() => setOpen(false)}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent dividers>
//           <TextField
//             margin="dense"
//             label="שם מוצר"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             sx={{ marginBottom: '20px' }}
//           />
//           <TextField
//             margin="dense"
//             label="קטגוריה"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={category}
//             onChange={(e) => setCategory(e.target.value)}
//             sx={{ marginBottom: '20px' }}
//           />
//           <TextField
//             margin="dense"
//             label="תיאור"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             sx={{ marginBottom: '20px' }}
//           />
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={isAvailable}
//                 onChange={(e) => setIsAvailable(e.target.checked)}
//                 color="primary"
//               />
//             }
//             label="במלאי"
//             sx={{ marginBottom: '20px' }}
//           />
//           <TextField
//             margin="dense"
//             label="כתובת תמונה"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={image}
//             onChange={(e) => setImage(e.target.value)}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpen(false)} color="secondary">ביטול</Button>
//           <Button onClick={handleSaveProductChanges} color="primary">שמור שינויים</Button>
//         </DialogActions>
//       </Dialog>

//       {/* User Management Modal */}
//       <Dialog open={openUserModal} onClose={() => setOpenUserModal(false)} maxWidth="sm" fullWidth>
//         <DialogTitle>ניהול משתמשים</DialogTitle>
//         <DialogContent dividers sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
//           {users.map(user => (
//             <Box key={user.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
//               <Typography variant="body2">{user.username}</Typography>
//               <Typography variant="body2" color="textSecondary">{user.status}</Typography>
//               <Box>
//                 <IconButton onClick={() => handleUserApproval(user.id)} color="primary" size="small">
//                   <CheckCircleIcon fontSize="small" />
//                 </IconButton>
//                 <IconButton onClick={() => handleEditUser(user)} color="primary" size="small">
//                   <EditIcon fontSize="small" />
//                 </IconButton>
//                 <IconButton onClick={() => handleDeleteUser(user.id)} color="secondary" size="small">
//                   <DeleteIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             </Box>
//           ))}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenUserModal(false)} color="primary">סגור</Button>
//         </DialogActions>
//       </Dialog>

//       {/* User Edit Modal */}
//       <Dialog open={openUserEditModal} onClose={handleCloseUserEditModal} maxWidth="sm" fullWidth>
//         <DialogTitle>עריכת משתמש</DialogTitle>
//         <DialogContent dividers>
//           <TextField label="שם משתמש" value={username} onChange={(e) => setUsername(e.target.value)} fullWidth margin="dense" />
//           <TextField label="סיסמה" type="password" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth margin="dense" />
//           <Select value={role} onChange={(e) => setRole(e.target.value)} fullWidth displayEmpty margin="dense">
//             <MenuItem value="" disabled>בחר תפקיד</MenuItem>
//             <MenuItem value="user">משתמש</MenuItem>
//             <MenuItem value="orderManager">מנהל הזמנות</MenuItem>
//             <MenuItem value="warehouseManager">מנהל מחסן</MenuItem>
//             <MenuItem value="admin">מנהל מערכת</MenuItem>
//           </Select>
//           <Select value={status} onChange={(e) => setStatus(e.target.value)} fullWidth displayEmpty margin="dense">
//             <MenuItem value="" disabled>בחר מצב</MenuItem>
//             <MenuItem value="מאושר">מאושר</MenuItem>
//             <MenuItem value="unconfirmed">לא מאושר</MenuItem>
//           </Select>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseUserEditModal} color="secondary">ביטול</Button>
//           <Button onClick={handleSaveUserChanges} color="primary">שמור שינויים</Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default ManageItemsK;




import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, collection, getDocs, addDoc, deleteDoc, updateDoc, doc } from '../firebase';
import * as XLSX from 'xlsx';
import {
  Container, Grid, Card, CardContent, CardMedia, Typography, Button, Box, TextField,
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Switch, FormControlLabel, MenuItem, Select
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from '../AuthContext';
import { useSelector } from 'react-redux';

const ManageItemsK = () => {
  const [items, setItems] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openItemModal, setOpenItemModal] = useState(false);
  const [openUserModal, setOpenUserModal] = useState(false);
  const [openUserEditModal, setOpenUserEditModal] = useState(false);
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');
  const [description, setDescription] = useState('');
  const [isAvailable, setIsAvailable] = useState(false);
  const [image, setImage] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('');
  const [status, setStatus] = useState('');
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.currentUser);

  useEffect(() => {
    if (!user || user.role !== 'admin') {
      navigate('/loginK');
      return;
    }
    fetchItems();
    fetchUsers();
  }, [user, navigate]);

  const fetchItems = async () => {
    const itemsCollection = await getDocs(collection(db, 'items_clear'));
    const itemsData = itemsCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setItems(itemsData);
  };

  const fetchUsers = async () => {
    const usersCollection = await getDocs(collection(db, 'users'));
    const usersData = usersCollection.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setUsers(usersData);
  };

  const handleUserApproval = async (userId) => {
    await updateDoc(doc(db, 'users', userId), { status: 'מאושר' });
    fetchUsers();
  };

  const handleDeleteUser = async (userId) => {
    await deleteDoc(doc(db, 'users', userId));
    fetchUsers();
  };

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setUsername(user.username);
    setPassword(user.password);
    setRole(user.role);
    setStatus(user.status);
    setOpenUserEditModal(true);
  };

  const handleSaveUserChanges = async () => {
    if (selectedUser) {
      await updateDoc(doc(db, 'users', selectedUser.id), {
        username,
        password,
        role,
        status,
      });
      fetchUsers();
      setOpenUserEditModal(false);
    }
  };

  const handleCloseUserEditModal = () => {
    setOpenUserEditModal(false);
    setSelectedUser(null);
    setUsername('');
    setPassword('');
    setRole('');
    setStatus('');
  };

  const handleClickOpenAddProduct = () => {
    setSelectedItem(null);
    setName('');
    setCategory('');
    setDescription('');
    setIsAvailable(false);
    setImage('');
    setOpenItemModal(true);
  };

  const handleSaveProductChanges = async () => {
    if (selectedItem) {
      await updateDoc(doc(db, 'items_clear', selectedItem.id), {
        name,
        category,
        description,
        isAvailable,
        image,
      });
    } else {
      await addDoc(collection(db, 'items_clear'), {
        name,
        category,
        description,
        isAvailable,
        image,
      });
    }
    fetchItems();
    handleCloseItemModal();
  };

  const handleCloseItemModal = () => {
    setOpenItemModal(false);
    setSelectedItem(null);
    setName('');
    setCategory('');
    setDescription('');
    setIsAvailable(false);
    setImage('');
  };

  const handleDeleteItem = async (id) => {
    await deleteDoc(doc(db, 'items_clear', id));
    fetchItems();
  };

  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(items);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Items');
    XLSX.writeFile(workbook, 'items.xlsx');
  };

  return (
    <Container
      sx={{
        paddingTop: '20px',
        backgroundColor: '#f0f0f0',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      }}
    >
      <Box sx={{ marginBottom: '20px', display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
        <Button variant="contained" color="primary" onClick={handleClickOpenAddProduct} sx={{ fontSize: '0.8rem' }}>הוסף מוצר חדש</Button>
        <Button variant="contained" color="primary" onClick={downloadExcel} sx={{ fontSize: '0.8rem' }}>ייצוא לאקסל</Button>
        <Button variant="contained" color="info" onClick={() => setOpenUserModal(true)} sx={{ fontSize: '0.8rem' }}>ניהול משתמשים</Button>
        <Button variant="contained" color="secondary" onClick={() => navigate('/order_g')} sx={{ fontSize: '0.8rem' }}>לוח מחוונים</Button>
      </Box>

      <Box sx={{ maxHeight: '60vh', overflowY: 'auto', width: '100%' }}>
        <Grid container spacing={1}>
          {items.map(item => (
            <Grid item xs={6} sm={3} md={2} key={item.id}>
              <Card sx={{ backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden', textAlign: 'center' }}>
                <CardMedia component="img" alt={item.name} image={item.image} sx={{ width: '100%', height: '60px', objectFit: 'cover' }} />
                <CardContent>
                  <Typography variant="body2" noWrap sx={{ fontSize: '12px', fontWeight: 'bold' }}>{item.name}</Typography>
                  <Button variant="contained" color="primary" size="small" onClick={() => handleClickOpenAddProduct(item)} sx={{ mt: 1 }}>ערוך</Button>
                  <Button variant="contained" color="secondary" size="small" onClick={() => handleDeleteItem(item.id)} sx={{ mt: 1 }}>מחק</Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Product Edit Modal */}
      <Dialog open={openItemModal} onClose={handleCloseItemModal} maxWidth="sm" fullWidth>
        <DialogTitle>{selectedItem ? 'עריכת מוצר' : 'הוספת מוצר'}</DialogTitle>
        <DialogContent dividers>
          <TextField label="שם מוצר" type="text" fullWidth variant="outlined" value={name} onChange={(e) => setName(e.target.value)} sx={{ marginBottom: '10px' }} />
          <TextField label="קטגוריה" type="text" fullWidth variant="outlined" value={category} onChange={(e) => setCategory(e.target.value)} sx={{ marginBottom: '10px' }} />
          <TextField label="תיאור" type="text" fullWidth variant="outlined" value={description} onChange={(e) => setDescription(e.target.value)} sx={{ marginBottom: '10px' }} />
          <FormControlLabel control={<Switch checked={isAvailable} onChange={(e) => setIsAvailable(e.target.checked)} color="primary" />} label="במלאי" sx={{ marginBottom: '10px' }} />
          <TextField label="כתובת תמונה" type="text" fullWidth variant="outlined" value={image} onChange={(e) => setImage(e.target.value)} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseItemModal} color="secondary">ביטול</Button>
          <Button onClick={handleSaveProductChanges} color="primary">שמור שינויים</Button>
        </DialogActions>
      </Dialog>

      {/* User Management Modal */}
      <Dialog open={openUserModal} onClose={() => setOpenUserModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle>ניהול משתמשים</DialogTitle>
        <DialogContent dividers sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
          {users.map(user => (
            <Box key={user.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="body2">{user.username}</Typography>
              <Typography variant="body2" color="textSecondary">{user.status}</Typography>
              <Box>
                <IconButton onClick={() => handleUserApproval(user.id)} color="primary" size="small">
                  <CheckCircleIcon fontSize="small" />
                </IconButton>
                <IconButton onClick={() => handleEditUser(user)} color="primary" size="small">
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton onClick={() => handleDeleteUser(user.id)} color="secondary" size="small">
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenUserModal(false)} color="primary">סגור</Button>
        </DialogActions>
      </Dialog>

      {/* User Edit Modal */}
      <Dialog open={openUserEditModal} onClose={handleCloseUserEditModal} maxWidth="sm" fullWidth>
        <DialogTitle>עריכת משתמש</DialogTitle>
        <DialogContent dividers>
          <TextField label="שם משתמש" value={username} onChange={(e) => setUsername(e.target.value)} fullWidth margin="dense" />
          <TextField label="סיסמה" type="password" value={password} onChange={(e) => setPassword(e.target.value)} fullWidth margin="dense" />
          <Select value={role} onChange={(e) => setRole(e.target.value)} fullWidth displayEmpty margin="dense">
            <MenuItem value="" disabled>בחר תפקיד</MenuItem>
            <MenuItem value="user">משתמש</MenuItem>
            <MenuItem value="orderManager">מנהל הזמנות</MenuItem>
            <MenuItem value="warehouseManager">מנהל מחסן</MenuItem>
            <MenuItem value="admin">מנהל מערכת</MenuItem>
          </Select>
          <Select value={status} onChange={(e) => setStatus(e.target.value)} fullWidth displayEmpty margin="dense">
            <MenuItem value="מאושר">מאושר</MenuItem>
            <MenuItem value="unconfirmed">לא מאושר</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseUserEditModal} color="secondary">ביטול</Button>
          <Button onClick={handleSaveUserChanges} color="primary">שמור שינויים</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ManageItemsK;
